import { useCallback } from 'react'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'

interface UseReCaptchaV3 {
  getReCaptchaToken: (action: string) => Promise<unknown>
}

function useReCaptchaV3(): UseReCaptchaV3 {
  const { executeRecaptcha } = useGoogleReCaptcha()

  const getReCaptchaToken = useCallback(
    async (action: string) => {
      if (!executeRecaptcha) {
        return undefined
      } else {
        return await executeRecaptcha(action)
      }
    },
    [executeRecaptcha],
  )

  return { getReCaptchaToken }
}

export default useReCaptchaV3
